import { handleRequest } from '_services';
import { normalize } from 'normalizr';
import { masterDataSchema } from '_services/_schemas';

export const masterDataService = {
    loadAll
};

async function loadAll() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/masterdata/all', requestOptions, true)
        .then(data => {
            var flat = normalize(data, masterDataSchema);
            return flat;
        });

}

